import { render, staticRenderFns } from "./PMChartBpc.vue?vue&type=template&id=73f8dd04&"
import script from "./PMChartBpc.vue?vue&type=script&lang=ts&"
export * from "./PMChartBpc.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartBpc.vue?vue&type=style&index=0&id=73f8dd04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports